import Contact from "@/components/Contact";
import useDocumentMeta from "@/lib/useDocumentMeta";

export default function ContactPage() {
    useDocumentMeta({
        title: "Контакти · Konstantin Mobile — Адрес, Телефон, Имейл",
        description:
            "Свържете се с Konstantin Mobile, Петрич. Телефон: +359 887 444 432, имейл: konstantin.bg.eood@gmail.com. Работно време: Пон–Пет 09:00–19:00.",
        path: "/contact",
    });
    return (
        <main data-testid="contact-page" className="pt-24">
            <Contact />
        </main>
    );
}
